__turbopack_context__.v({
  "black": "Tag-module-scss-module__feuXEW__black",
  "hoverState": "Tag-module-scss-module__feuXEW__hoverState",
  "red": "Tag-module-scss-module__feuXEW__red",
  "redOutline": "Tag-module-scss-module__feuXEW__redOutline",
  "tag": "Tag-module-scss-module__feuXEW__tag",
});
